export const CorporateContractType = {
    ALPHA: "آلفا",
    PRO: "پرو",
    NEO: "نئو",
    PERSONAL: "شخصی",
    NON_WITHDRAWABLE: "خرید",
}
